var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcaseOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.83667C12.0937 9.60749 10.0563 10.0025 8 10C5.878 10 3.85333 9.58667 2 8.83667M10.6667 4V2.66667C10.6667 2.31305 10.5262 1.97391 10.2761 1.72386C10.0261 1.47381 9.68696 1.33334 9.33333 1.33334H6.66667C6.31304 1.33334 5.97391 1.47381 5.72386 1.72386C5.47381 1.97391 5.33333 2.31305 5.33333 2.66667V4M8 8H8.00667M3.33333 13.3333H12.6667C13.0203 13.3333 13.3594 13.1929 13.6095 12.9428C13.8595 12.6928 14 12.3536 14 12V5.33334C14 4.97971 13.8595 4.64058 13.6095 4.39053C13.3594 4.14048 13.0203 4 12.6667 4H3.33333C2.97971 4 2.64057 4.14048 2.39052 4.39053C2.14048 4.64058 2 4.97971 2 5.33334V12C2 12.3536 2.14048 12.6928 2.39052 12.9428C2.64057 13.1929 2.97971 13.3333 3.33333 13.3333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseOutline);
export default __webpack_public_path__ + "static/media/BriefcaseOutline.7768639fd57daadc5c15e274c1670462.svg";
export { ForwardRef as ReactComponent };